export default __webpack_public_path__ + "static/media/slide-one.b7467e47.jpg";